export default __webpack_public_path__ + "static/media/loan.ba289924.jpg";